import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.danger_500};
    color: ${({ theme }) => theme.neutral_100};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
